import {Button, Dialog, Pane, TextInputField, toaster} from "evergreen-ui";
import React from "react";
import SmartButton from "../common/SmartButton";

export default function CreateTemplateDialog({isShown, setIsShown, createTemplate}) {

    const [templateName, setTemplateName] = React.useState("")


    function isCreateButtonDisabled() {
        return templateName.trim().length === 0
    }

    function getMessageForTooltip() {
        if (isCreateButtonDisabled()) {
            return "Введите наименование шаблона"
        }
    }

    return (
        <Dialog
            isShown={isShown}
            onCancel={() => setIsShown(false)}
            title="Создание шаблона"
            cancelLabel="Отменить"

            footer={
                <Pane>
                    <Button marginRight={5} onClick={() => {setIsShown(false); console.log("SHOULD CLODE")}}>Отменить</Button>

                    <SmartButton
                        disabledTooltip={getMessageForTooltip()}
                        buttonText={"Создать"}
                        isPrimary={true}
                        isDisabled={isCreateButtonDisabled()}
                        onClickAction={() => {
                            createTemplate(templateName)
                        }}
                    />
                </Pane>
            }
            onCloseComplete={() => setIsShown(false)}
        >
            <Pane marginRight={30}>
                <TextInputField
                    label="Введите наименование шаблона"
                    width={413}
                    onChange={e => setTemplateName(e.target.value)}
                />
            </Pane>
        </Dialog>
    )
}